export default {
    path: 'revenue_menu',
    component: () => import('@/pages/menus/RevenueMenu'),
    meta: {title:'营收'},
    children: [
        {
            path: 'revenue_statistics',
            name: 'revenue_statistics',
            component: () => import('@/pages/revenue/data/RevenueStatistics'),
            meta: { title: '总营收一览', alive: true },
        },
        {
            path: 'revenue_rank',
            name: 'revenue_rank',
            component: () => import('@/pages/rank/RevenueRank'),
            meta: { title: '总营收一览', alive: true },
        },
        {
            path: 'commission_list',
            name: 'commission_list',
            component: () => import('@/pages/revenue/data/CommissionList'),
            meta: { title: '佣金收入', alive: true },
        },
        {
            path: 'order_statistics',
            name: 'order_statistics',
            component: () => import('@/pages/revenue/order/StatisticsTable'),
            meta: { title: '实时订单排行' , alive: true},
        },
        {
            path: 'growth_statistics',
            name: 'growth_statistics',
            component: () => import('@/pages/revenue/growth/GrowthIndex'),
            meta: { title: '孵化分析', alive: true },
        },
    ]
}
